import { generatePath } from 'react-router';

import { Navigate, useTypedParams } from '@sorare/routing';

import { FOOTBALL_SCOUTING_CENTER_STATS_SO5_COMPETITION_SLUG } from '@sorare/core/src/constants/__generated__/routes';

import type { PageParams } from './__generated__/routeParams';

const ScoutingCenterSo5CompetitionRedirect = () => {
  const { slug } = useTypedParams<PageParams>();
  return (
    <Navigate
      to={generatePath(FOOTBALL_SCOUTING_CENTER_STATS_SO5_COMPETITION_SLUG, {
        slug,
      })}
    />
  );
};

export default ScoutingCenterSo5CompetitionRedirect;
